export function fromHex(hex: string): Uint8Array<ArrayBuffer> {
  if (hex.length % 2 !== 0) {
    throw new Error('Hex string must have an even length');
  }
  const array = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    const byte = parseInt(hex.slice(i, i + 2), 16);
    if (isNaN(byte)) {
      throw new Error(`Invalid hex byte: ${hex.slice(i, i + 2)}`);
    }
    array[i / 2] = byte;
  }
  return array;
}

export function toHex(array: Uint8Array<ArrayBufferLike>) {
  return Array.from(array)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
